import { State, Action, StateContext, Selector } from '@ngxs/store';
import { EditPaintStateModel } from './edit.paint.state.model';
import { SetColorRecipe, ClearColorRecipe, ResetPaint, SetPaintBrushMode } from './edit.paint.actions';
import { PaintPresetRed } from 'src/app/engine/models/paint-presets.const';
import { PaintBrushMode } from '../../models/paint-brush-mode.enum';
import { Injectable } from '@angular/core';

const initialState = {
  colorRecipe: PaintPresetRed.recipe,
  brushMode: PaintBrushMode.Modify
};

@State<EditPaintStateModel>({
  name: 'editPaint',
  defaults: initialState 
})
@Injectable()
export class EditPaintState {
  /**
   * Selectors
   */
  @Selector()
  static getColorRecipe(state: EditPaintStateModel) {
    return state.colorRecipe;
  }

  @Selector()
  static getPaintBrushMode(state: EditPaintStateModel) {
    return state.brushMode;
  }

  /**
   * Actions
   */
  @Action(SetColorRecipe)
  setColorRecipe(context: StateContext<EditPaintStateModel>, { colorRecipe }: SetColorRecipe) {
    context.patchState({
      colorRecipe
    });
  }

  @Action(SetPaintBrushMode)
  setBrushMode(context: StateContext<EditPaintStateModel>, action: SetPaintBrushMode) {
    context.patchState({
      brushMode: action.brushMode
    });
  }

  @Action(ClearColorRecipe)
  clearColorRecipe(context: StateContext<EditPaintStateModel>, action: ClearColorRecipe) {
    context.patchState({
      colorRecipe: null
    });
  }
  
  @Action(ResetPaint)
  resetPaint(context: StateContext<EditPaintStateModel>, action: ResetPaint) {
    context.setState(initialState);
  }

  constructor(
  ) { }
}
